module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/tr-select.e9f03180.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/tr-select.png
// module id = 2765
// module chunks = 11